<template>
	<div class="operation_box">
		<!-- Table Actions -->
		<div class="operation_item" v-if="allowedActions.length > 0">
			<el-dropdown split-button type="primary"
						 @click="allowedActions[0].execute"
						 @command="(command) => command()"
			>
				<i :class="allowedActions[0].icon"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="action in allowedActions"
									  :key="action.key"
									  :icon="action.icon"
									  :command="action.execute">
						{{ $t(action.key) }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {enumDef} from "@/common/enumDefs";

export default {
	data() {
		return {
			actionList: [
				{
					key: "revolvingPutOption.table.operation.showPaymentPlan",
					icon: "fa fa-search-plus",
					execute: this.showPaymentPlan
				},
				{
					key: "revolvingPutOption.table.operation.showReceivables",
					icon: "fa fa-list",
					execute: this.showReceivables
				},
				{
					key: "revolvingPutOption.table.operation.downloadContract",
					icon: "fa fa-cloud-download",
					isEnabled: () => { return this.hasContractFile; },
					execute: this.downloadContract
				},
				// Deprecated since DEV-3519
				/*{
					key: "revolvingPutOption.table.operation.cancelContractOrdinary",
					icon: "fa fa-ban",
					isEnabled: () => { return this.canCancel; },
					execute: this.cancelOrdinary
				},*/
				{
					key: "revolvingPutOption.table.operation.cancelContractExtraordinary",
					icon: "fa fa-times",
					isEnabled: () => { return this.canCancel; },
					execute: this.cancelExtraordinary
				},
			]
		};
	},
	computed: {
		allowedActions() {
			return this.actionList.filter(action => !action.isEnabled || action.isEnabled());
		},
		hasContractFile() {
			return this.params.data.contractFileId;
		},
		canCancel() {
			return enumDef.revolvingPutOptionStatus.isAcceptedOrRunning(this.params.data.status);
		}
	},
	methods: {
		handleActionCommand(command) {
			command();
		},
		showPaymentPlan() {
			this.params.showPaymentPlan(this.params.data);
		},
		showReceivables() {
			this.params.showReceivables(this.params.data);
		},
		downloadContract() {
			let pdfUrl = fileuploadApi.getPdfUrl(this.params.data.contractFileId);
			window.open(pdfUrl, "_blank");
		},
		cancelOrdinary() {
			this.params.cancelOrdinary(this.params.data);
		},
		cancelExtraordinary() {
			this.params.cancelExtraordinary(this.params.data);
		}
	}
};
</script>